import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import VueScrollTo from 'vue-scrollto'
import './assets/scss/app.scss'

Vue.use(Buefy)
Vue.use(VueScrollTo)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  data() {
    return {
      hoverId: 'qwe'
    }
  }
}).$mount('#app')
